import { render, staticRenderFns } from "./EditModel.vue?vue&type=template&id=ebd51838&"
import script from "./EditModel.vue?vue&type=script&lang=ts&"
export * from "./EditModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports